import React, { useState, useEffect } from 'react'
import { getBarangayLogoUrl, getBarangayBackgroundUrl } from '../../lib/imageUtils'

const BarangayHero = ({ barangay }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const logoUrl = getBarangayLogoUrl(barangay.logo_url)
  const backgroundUrl = getBarangayBackgroundUrl(barangay.home_background_url)

  const backgroundStyle = {
    backgroundImage: backgroundUrl
      ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundUrl})`
      : 'linear-gradient(135deg, #003978 0%, #e02f29 100%)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: isMobile ? '60vh' : '70vh'
  }

  return (
    <div className="header-banner bg-theme-dark">
      <div className="nk-banner">
        <div className="banner banner-fs tc-light" style={backgroundStyle}>
          <div className="banner-wrap">
            <div className="container" style={{ paddingTop: '120px', paddingBottom: '80px' }}>
              <div className="row align-items-center justify-content-center">
                <div className="col-lg-8 text-center">
                  {logoUrl && (
                    <div className="mb-4">
                      <img
                        src={logoUrl}
                        alt={`${barangay.name} Logo`}
                        style={{
                          maxWidth: '150px',
                          maxHeight: '150px',
                          filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3))'
                        }}
                        onError={(e) => {
                          console.error('Failed to load logo:', logoUrl)
                          e.target.style.display = 'none'
                        }}
                      />
                    </div>
                  )}
                  <h1 className="title title-xl-2 mb-3">
                    {barangay.name}
                  </h1>
                  {barangay.barangay_no && (
                    <p className="lead" style={{ color: '#ffd700' }}>
                      {barangay.address}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BarangayHero
